var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseEntity } from "../../../pages/modules/base-entity";
import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { StepEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { BrandClientService } from "../../../../services/modules/brand-client.service";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { RouterConstants } from "../../../../configuration/router.constants";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { I18N } from "aurelia-i18n";
import { AttachmentClientService } from "../../../../services/modules/attachements-client.service";
import * as Enumerable from "linq";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { Guid } from "../../../../utilities/guid";
import { ValidationControllerFactory, validateTrigger, ValidationRules } from "aurelia-validation";
import { LotteryInsurancePrint } from "./steps/lottery-insurance-print";
import { BrandChangeLog } from "./steps/brand-changelog";
import { InsuranceDataHandler } from "./insurance-handler";
import { BrandBasicMeta } from "./steps/brand-basic-meta";
import { BrandAnalytics } from "./steps/brand-analytics";
import { BrandTransactions } from "./steps/brand-transactions";
import { BrandLotteries } from "./steps/brand-lotteries";
import { LotteryInsurance } from "./steps/lottery-insurance";
import { BrandPlayers } from "./steps/brand-players";
import { BrandSettings } from "./steps/brand-settings";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { BaseClaims } from "../../../../constants/authentication/base-claims";
import { Billing } from "./steps/billing";
import { LotteryPlatformClaims } from "../../../../constants/modules/lotteryplatform.claims";
import { BrandNotifications } from "./steps/brand-notifications";
import { BrandBundles } from "./steps/brand-bundles";
import { BrandInstantGames } from "./steps/brand-instant-games";
import { LotteryGrouping } from "./steps/lottery-grouping";
import { BrandSweepstakes } from "./steps/brand-sweepstakes";
import { BrandRenderEditor } from "./steps/brand-render-editor";
var Brand = /** @class */ (function (_super) {
    __extends(Brand, _super);
    function Brand(dialogClientService, router, tokenClient, bindingEngine, notificationService, eventAggregator, brandClientService, brandBasicMeta, brandAnalytics, brandTransactions, brandLotteries, brandInstantGames, brandSweepstakes, brandBundles, lotteryInsurance, lotteryInsurancePrint, attachmentClientService, brandPlayers, brandSettings, lotteryGrouping, brandChangeLog, userClaimsService, validationControllerFactory, insuranceDataHandler, billing, brandNotifications, brandRenderEditor, i18N, dialogClient) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.router = router;
        _this.tokenClient = tokenClient;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.brandClientService = brandClientService;
        _this.brandBasicMeta = brandBasicMeta;
        _this.brandAnalytics = brandAnalytics;
        _this.brandTransactions = brandTransactions;
        _this.brandLotteries = brandLotteries;
        _this.brandInstantGames = brandInstantGames;
        _this.brandSweepstakes = brandSweepstakes;
        _this.brandBundles = brandBundles;
        _this.lotteryInsurance = lotteryInsurance;
        _this.lotteryInsurancePrint = lotteryInsurancePrint;
        _this.attachmentClientService = attachmentClientService;
        _this.brandPlayers = brandPlayers;
        _this.brandSettings = brandSettings;
        _this.lotteryGrouping = lotteryGrouping;
        _this.brandChangeLog = brandChangeLog;
        _this.userClaimsService = userClaimsService;
        _this.validationControllerFactory = validationControllerFactory;
        _this.billing = billing;
        _this.brandNotifications = brandNotifications;
        _this.brandRenderEditor = brandRenderEditor;
        _this.dialogClient = dialogClient;
        _this.activityLogEntitiesSave = [EntityTypes.Brand];
        _this.controller = null;
        // The Render Engine editor tab has its own Save/Publish, so the page-level Delete/Cancel/Save bar is
        // hidden while it's active. Driven by entity-item's onStepClicked callback.
        _this.isRenderEditorStep = false;
        _this.onStepChanged = function (step) {
            _this.isRenderEditorStep = !!step && step.step === StepEnum.BrandRenderEditor;
        };
        _this.lotteryInsurance.insuranceDataHandler = insuranceDataHandler;
        _this.lotteryInsurancePrint.insuranceDataHandler = insuranceDataHandler;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Brand.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Brand.prototype.attached = function () {
        this.canDeleteBrand = this.userClaimsService.hasPermission(LotteryPlatformClaims.DeleteBrand);
        this.updatePermissions();
        return _super.prototype.attached.call(this);
    };
    Brand.prototype.updatePermissions = function () {
        if (!('brandId' in this.item))
            return;
        var isEditable = false;
        if (this.userClaimsService.hasPermission(LotteryPlatformClaims.EditBrands))
            isEditable = true;
        else {
            isEditable = !(this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewBrands)
                && !this.userClaimsService.hasPermission(LotteryPlatformClaims.EditBrands));
        }
        if (this.item) {
            this.item.isEditable = isEditable;
        }
        this.billing.isEditable = isEditable;
        this.lotteryInsurance.isEditable = isEditable;
    };
    Brand.prototype.deleteBrand = function () {
        var _this = this;
        require("../dialogs/delete-modal"); // this is to show delete modal dialog
        if (this.item.brandId) {
            this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                delete: function () { return new Promise(function (resolve, reject) {
                    _this.brandClientService.delete({ brandId: _this.item.brandId }).then(function (response) {
                        if (response.deleteSuccessfully) {
                            _this.notificationService.show(_this.i18N.tr("brand-delete-notification-title"), _this.i18N.tr("brand-delete-notification-message-success"), NotificationType.Success);
                            _this.router.navigateToRoute(_this.getListRoute());
                            resolve();
                        }
                        else {
                            _this.notificationService.show(_this.i18N.tr("brand-delete-notification-title"), _this.i18N.tr("brand-delete-notification-message-error"), NotificationType.Error);
                            reject();
                        }
                    }).catch(function () {
                        _this.notificationService.show(_this.i18N.tr("operator-delete-notification-title"), _this.i18N.tr("brand-delete-notification-message-error"), NotificationType.Error);
                        reject();
                    });
                }); }
            });
        }
    };
    Object.defineProperty(Brand.prototype, "defaultBrand", {
        get: function () {
            return {
                templateId: null,
                brandThemeId: null,
                isActive: true,
                showNavMenu: true,
                enableLoginDialog: true,
                isOpen: true,
                isSelected: false,
                createdDate: null,
                aggregatePoints: false,
                brandId: 0,
                name: "",
                image: "",
                securityKey: null,
                brandUsers: [],
                brandUrls: [],
                brandCreditTransfers: [],
                lotteryPricingModels: [],
                brandLotteries: [],
                bundles: [],
                authenticatePlayerUrl: null,
                failOnInsufficientCredit: false,
                firstInsufficientCreditAlertInEuro: null,
                secondInsufficientCreditAlertInEuro: null,
                insufficientCreditAlertEmail: null,
                getPlayerBalanceUrl: null,
                debitPlayerUrl: null,
                creditPlayerUrl: null,
                winningClaimsNotificationUrl: null,
                noWinPlayerUrl: null,
                ticketPlacedUrl: null,
                entityType: EntityTypes.Brand,
                identifier: Guid.generateGuid(),
                operatorId: null,
                operatorMargin: null,
                platformMargin: null,
                instantGamesOperatorMargin: null,
                instantGamesPlatformMargin: null,
                bundlesOperatorMargin: null,
                bundlesPlatformMargin: null,
                syndicatesOperatorMargin: null,
                syndicatesPlatformMargin: null,
                sweepstakesOperatorMargin: null,
                sweepstakesPlatformMargin: null,
                minOperatorMargin: null,
                minPlatformMargin: null,
                skipWorkflowThreshold: null,
                maxOperatorMargin: null,
                maxPlatformMargin: null,
                winningsThreshold: null,
                isOperatorMarginPercentage: false,
                isPlatformMarginPercentage: false,
                isOperatorMarginPercentageGross: false,
                useOperatorCredit: true,
                useBrandCredit: false,
                isPlatformMarginPercentageGross: false,
                instantGamesMinOperatorMargin: null,
                instantGamesMinPlatformMargin: null,
                instantGamesMaxOperatorMargin: null,
                instantGamesMaxPlatformMargin: null,
                isInstantGamesOperatorMarginPercentage: false,
                isInstantGamesPlatformMarginPercentage: false,
                isInstantGamesOperatorMarginPercentageGross: false,
                isInstantGamesPlatformMarginPercentageGross: false,
                isBrandLevelLotteryMarginCost: false,
                bundlesMinOperatorMargin: null,
                bundlesMinPlatformMargin: null,
                bundlesMaxOperatorMargin: null,
                bundlesMaxPlatformMargin: null,
                isBundlesOperatorMarginPercentage: false,
                isBundlesPlatformMarginPercentage: false,
                isBundlesOperatorMarginPercentageGross: false,
                isBundlesPlatformMarginPercentageGross: false,
                syndicatesMinOperatorMargin: null,
                syndicatesMinPlatformMargin: null,
                syndicatesMaxOperatorMargin: null,
                syndicatesMaxPlatformMargin: null,
                isSyndicatesOperatorMarginPercentage: false,
                isSyndicatesPlatformMarginPercentage: false,
                isSyndicatesOperatorMarginPercentageGross: false,
                isSyndicatesPlatformMarginPercentageGross: false,
                isOperatorMarginPercentagePlatformAndInsurance: false,
                isInstantGamesOperatorMarginPercentagePlatformAndInsurance: false,
                isBundlesOperatorMarginPercentagePlatformAndInsurance: false,
                isSyndicatesOperatorMarginPercentagePlatformAndInsurance: false,
                sweepstakesMinOperatorMargin: null,
                sweepstakesMinPlatformMargin: null,
                sweepstakesMaxOperatorMargin: null,
                sweepstakesMaxPlatformMargin: null,
                isSweepstakesOperatorMarginPercentage: false,
                isSweepstakesPlatformMarginPercentage: false,
                isSweepstakesOperatorMarginPercentageGross: false,
                isSweepstakesPlatformMarginPercentageGross: false,
                isSweepstakesOperatorMarginPercentagePlatformAndInsurance: false,
                lotteryPriceTierInsurancePolicies: [],
                brandLanguages: [],
                brandCurrencies: [],
                defaultCurrencyId: 0,
                defaultLanguageId: 0,
                winningsEmailNotification: null,
                brandNotifications: [],
                enableAgent: false,
                mlroName: null,
                complianceOfficeName: null,
                casinoManagerName: null,
                accountContactName: null,
                mlroSurname: null,
                complianceOfficeSurname: null,
                casinoManagerSurname: null,
                accountContactSurname: null,
                mlroEmail: null,
                complianceOfficeEmail: null,
                casinoManagerEmail: null,
                accountContactEmail: null,
                mlroPhoneNumber: null,
                complianceOfficePhoneNumber: null,
                casinoManagerPhoneNumber: null,
                accountContactPhoneNumber: null,
                mlroMobile: null,
                complianceOfficeMobile: null,
                casinoManagerMobile: null,
                accountContactMobile: null,
                mlroAddress: null,
                complianceOfficeAddress: null,
                casinoManagerAddress: null,
                accountContactAddress: null,
                referrerFees: null,
                clientTypeId: null,
                agentsCommission: null,
                iFrameToken: null,
                brandLotteryGroups: [],
                ticketPriceCurrencyId: null,
                instantGamePlayportOutcomeUrl: null,
                instantGamePlayportOutcomeAuthToken: null
            };
        },
        enumerable: false,
        configurable: true
    });
    Brand.prototype.initValidations = function (newItem) {
        var _this = this;
        var subscribedLotteriesCount = 0;
        if (Array.isArray(newItem.activeBrandLotteries))
            subscribedLotteriesCount = newItem.activeBrandLotteries.filter(function (x) { return x.isSubscribed; }).length;
        // does this brand has subscribed to any lotteries
        var hasSubscribedLotteries = subscribedLotteriesCount > 0;
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Brand name is required.")
            .ensure(function (x) { return x.operatorId; }).required().withMessage("Operator is required.")
            .ensure(function (x) { return x.templateId; }).required().withMessage("Template is required.")
            .ensure(function (x) { return x.brandLanguages; }).satisfies(function (x) { return x.length > 0; }).withMessage("At least one brand languages is required")
            .ensure(function (x) { return x.brandCurrencies; }).satisfies(function (x) { return x.length > 0; }).withMessage("At least one brand currency is required")
            .ensure(function (x) { return x.skipWorkflowThreshold; }).satisfies(function (x) { return !x || x < _this.tokenClient.kycWinningAmountThreshold; })
            .withMessage("Skip workflow threshold is bigger than KYC threshold")
            .ensure(function (x) { return x.brandUrls; })
            .satisfies(function (x) {
            var isValid = true;
            x.forEach(function (v) { if (v.url == null)
                isValid = false; });
            return isValid;
        }).withMessage("Brand url is required and cannot be left empty")
            //#region validation for Platform margin
            .ensure(function (x) { return x.activeBrandLotteries; })
            .satisfies(function (x) {
            if (subscribedLotteriesCount == 0)
                return true;
            // check if any one of the platform margin type is selected
            var isNoneOfPlatformMarginTypeSelected = (_this.item.isFixedPlatformLottery == false &&
                _this.item.isPlatformMarginPercentage == false &&
                _this.item.isPlatformMarginPercentageGross == false &&
                _this.item.isBrandLevelLotteryMarginCost == false);
            // failed if none of PlatformMargin types selected
            if (isNoneOfPlatformMarginTypeSelected)
                return false;
            return true;
        }).withMessage("Cannot Save Brand details since Lottery platform margin costs are not yet set and cannot be zero.")
            .satisfies(function (x) {
            if (!hasSubscribedLotteries)
                return true;
            // if @isBrandLevelLotteryMarginCost is enabled then no need to validate the @platformMargin
            if (_this.item.isBrandLevelLotteryMarginCost)
                return true;
            return Number(_this.item.platformMargin) > 0;
        }).withMessage("Lottery Platform margin cost/percentage should be greater than 0")
            .satisfies(function (x) {
            if (!hasSubscribedLotteries)
                return true;
            if (!_this.item.isPlatformMarginPercentage && !_this.item.isPlatformMarginPercentageGross)
                return true;
            // for types @isPlatformMarginPercentage and @isPlatformMarginPercentageGross, operatorMargin is required
            return Number(_this.item.minPlatformMargin) > 0;
        }).withMessage("Lottery minimum platform margin cost should be greater than 0")
            .satisfies(function (x) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hasSubscribedLotteries)
                            return [2 /*return*/, true];
                        if (!this.item.isBrandLevelLotteryMarginCost)
                            return [2 /*return*/, true];
                        return [4 /*yield*/, this.validateBrandMarginCostFlag()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); }).withMessage(this.i18N.tr('lottery-margin-cost-not-set-error-message'))
            //#endregion
            //#region Validation for Operator margin
            .ensure(function (x) { return x.activeBrandLotteries; })
            .satisfies(function (x) {
            if (!hasSubscribedLotteries)
                return true;
            // any one type of Operator margin need to be selected
            var isNoneOfOperatorMarginTypeSelected = (_this.item.isFixedOperatorLottery == false &&
                _this.item.isOperatorMarginPercentage == false &&
                _this.item.isOperatorMarginPercentageGross == false);
            if (isNoneOfOperatorMarginTypeSelected)
                return false;
            return true;
        }).withMessage("Cannot Save Brand details since Lottery Cost margins are not yet set and cannot be zero.")
            .satisfies(function (x) {
            if (!hasSubscribedLotteries)
                return true;
            return Number(_this.item.operatorMargin) > 0;
        }).withMessage("Lottery Operator margin cost/percentage should be greater than 0")
            .satisfies(function (x) {
            if (!hasSubscribedLotteries)
                return true;
            if (!_this.item.isOperatorMarginPercentage && !_this.item.isOperatorMarginPercentageGross)
                return true;
            // for types @isOperatorMarginPercentage and @isOperatorMarginPercentageGross, operatorMargin is required
            return Number(_this.item.minOperatorMargin) > 0;
        }).withMessage("Lottery Minimum Operator Margin cost should be greater than 0")
            //#endregion Validation for Operator margin
            //#region Validation related to instant games
            .ensure(function (x) { return x.activeBrandInstantGames; }).satisfies(function (x) {
            if (x != undefined && x.filter(function (x) { return x.isSubscribed; }).length > 0
                && (Number(_this.item.instantGamesPlatformMargin) == 0 || Number(_this.item.instantGamesOperatorMargin) == 0)
                || ((_this.item.isFixedOperatorInstant == false
                    && _this.item.isInstantGamesOperatorMarginPercentage == false
                    && _this.item.isInstantGamesOperatorMarginPercentageGross == false &&
                    _this.item.isInstantGamesOperatorMarginPercentagePlatformAndInsurance == false)
                    || (_this.item.isFixedPlatformInstant == false && _this.item.isInstantGamesPlatformMarginPercentage == false
                        && _this.item.isInstantGamesPlatformMarginPercentageGross == false)))
                return false;
            else
                return true;
        }).withMessage("Cannot Save Brand details since Instant Game Cost margins are not yet set and cannot be zero.")
            //#endregion Validation related to instant games
            //#region Validation related to bundles
            .ensure(function (x) { return x.bundles; }).satisfies(function (x) {
            if (x != undefined && x.filter(function (x) { return x.isActive; }).length > 0
                && (Number(_this.item.bundlesPlatformMargin) == 0 || Number(_this.item.bundlesOperatorMargin) == 0)
                || ((_this.item.isFixedOperatorBundle == false && _this.item.isBundlesOperatorMarginPercentage == false
                    && _this.item.isBundlesOperatorMarginPercentageGross == false
                    && _this.item.isBundlesOperatorMarginPercentagePlatformAndInsurance == false)
                    || (_this.item.isFixedPlatformBundle == false && _this.item.isBundlesPlatformMarginPercentage == false
                        && _this.item.isBundlesPlatformMarginPercentageGross == false)))
                return false;
            else
                return true;
        }).withMessage("Cannot Save Brand details since Bundles Cost margins are not yet set and cannot be zero.")
            //#endregion Validation related to bundles
            //#region Validation related to syndicates
            .ensure(function (x) { return x.activeBrandLotteries; })
            .satisfies(function (x) {
            if (x != undefined && x.filter(function (x) { return x.isSubscribed; }).length > 0)
                var areThereAnySyndicates = Enumerable.from(_this.item.activeBrandLotteries).where(function (x) { return x.isSubscribed; }).any(function (x) { return x.syndicates.length > 0; });
            if (areThereAnySyndicates
                && (Number(_this.item.syndicatesPlatformMargin) == 0 || Number(_this.item.syndicatesOperatorMargin) == 0)
                || ((_this.item.isFixedOperatorSyndicate == false && _this.item.isSyndicatesOperatorMarginPercentage == false
                    && _this.item.isSyndicatesOperatorMarginPercentageGross == false
                    && _this.item.isSyndicatesOperatorMarginPercentagePlatformAndInsurance == false)
                    || (_this.item.isFixedPlatformSyndicate == false && _this.item.isSyndicatesPlatformMarginPercentage == false
                        && _this.item.isSyndicatesPlatformMarginPercentageGross == false)))
                return false;
            else
                return true;
        }).withMessage("Cannot Save Brand details since Syndicates Cost margins are not yet set and cannot be zero.")
            //#endregion Validation related to syndicates
            //#region Validation related to Sweepstakes
            .ensure(function (x) { return x.activeBrandSweepstakes; }).satisfies(function (x) {
            if (!x || x.filter(function (x) { return x.isSubscribed; }).length == 0)
                return true;
            var sweepstakeMarginsAreNotSet = (Number(_this.item.sweepstakesPlatformMargin) == 0 || Number(_this.item.sweepstakesOperatorMargin) == 0);
            var operatorRadioButtonsAreNotSet = !_this.item.isFixedOperatorSweepstake && !_this.item.isSweepstakesOperatorMarginPercentage
                && !_this.item.isSweepstakesOperatorMarginPercentageGross && !_this.item.isSweepstakesOperatorMarginPercentagePlatformAndInsurance;
            var platformRadioButtonsAreNotSet = !_this.item.isFixedPlatformSweepstake && !_this.item.isSweepstakesPlatformMarginPercentage &&
                !_this.item.isSweepstakesPlatformMarginPercentageGross;
            if (sweepstakeMarginsAreNotSet || operatorRadioButtonsAreNotSet || platformRadioButtonsAreNotSet)
                return false;
            return true;
        }).withMessage("Cannot Save Brand details since Sweepstake Cost margins are not yet set and cannot be zero.")
            //#endregion Validation related to Sweepstakes
            .satisfies(function (x) {
            if (_this.item.maxPlatformMargin > 0 && _this.item.minPlatformMargin > _this.item.maxPlatformMargin)
                return false;
            else if (_this.item.maxOperatorMargin > 0 && _this.item.minOperatorMargin > _this.item.maxOperatorMargin)
                return false;
            else if (_this.item.instantGamesMaxPlatformMargin > 0 && _this.item.instantGamesMinPlatformMargin > _this.item.instantGamesMaxPlatformMargin)
                return false;
            else if (_this.item.instantGamesMaxOperatorMargin > 0 && _this.item.instantGamesMinOperatorMargin > _this.item.instantGamesMaxOperatorMargin)
                return false;
            else if (_this.item.bundlesMaxPlatformMargin > 0 && _this.item.bundlesMinPlatformMargin > _this.item.bundlesMaxPlatformMargin)
                return false;
            else if (_this.item.bundlesMaxOperatorMargin > 0 && _this.item.bundlesMinOperatorMargin > _this.item.bundlesMaxOperatorMargin)
                return false;
            else if (_this.item.syndicatesMaxPlatformMargin > 0 && _this.item.syndicatesMinPlatformMargin > _this.item.syndicatesMaxPlatformMargin)
                return false;
            else if (_this.item.syndicatesMaxOperatorMargin > 0 && _this.item.syndicatesMinOperatorMargin > _this.item.syndicatesMaxOperatorMargin)
                return false;
            else if (_this.item.sweepstakesMaxPlatformMargin > 0 && _this.item.sweepstakesMinPlatformMargin > _this.item.sweepstakesMaxPlatformMargin)
                return false;
            else if (_this.item.sweepstakesMaxOperatorMargin > 0 && _this.item.sweepstakesMinOperatorMargin > _this.item.sweepstakesMaxOperatorMargin)
                return false;
            return true;
        }).withMessage("Maximum Margin value cannot be less than Minimum Margin value")
            .ensure(function (x) { return x.brandLotteryGroups; })
            .satisfies(function (brandLotteryGroups) {
            if (!brandLotteryGroups || brandLotteryGroups.length == 0)
                return true;
            var brandLotteryGroupEnumerable = Enumerable.from(_this.item.brandLotteryGroups);
            if (brandLotteryGroupEnumerable.any(function (x) { return x.brandLotteryGroupItems.length == 0; })) {
                _this.notificationService.show("Validation Error!", "A group must have atleast one lottery", NotificationType.Error);
                return false;
            }
            var anyDuplicateGroupName = brandLotteryGroupEnumerable
                .groupBy(function (x) { return x.brandLotteryGroupId; })
                .any(function (c) { return c.count() > 1; });
            if (anyDuplicateGroupName) {
                _this.notificationService.show("Validation Error!", "Group name must be unique and can't be used multiple times", NotificationType.Error);
                return false;
            }
            var invalidLotteryIds = brandLotteryGroupEnumerable
                .where(function (x) { return Enumerable.from(x.brandLotteryGroupItems).any(function (y) { return !(y.brandLotteryId > 0); }); })
                .toArray();
            if (invalidLotteryIds.length > 0) {
                _this.notificationService.show("Validation Error!", "Lottery is required", NotificationType.Error);
                return false;
            }
            var duplicateLotteriesInAGroup = false;
            brandLotteryGroupEnumerable.forEach(function (groupItems) {
                var anyDuplicateLotteryId = Enumerable.from(groupItems.brandLotteryGroupItems)
                    .groupBy(function (x) { return x.brandLotteryId; })
                    .any(function (c) { return c.count() > 1; });
                if (anyDuplicateLotteryId)
                    duplicateLotteriesInAGroup = true;
            });
            if (duplicateLotteriesInAGroup) {
                _this.notificationService.show("Validation Error!", "A lottery must be selected only once on a group", NotificationType.Error);
                return false;
            }
            return true;
        })
            .ensure(function (x) { return x.winningsEmailNotification; })
            .satisfies(function (value) {
            if (!value || value.trim().length === 0) {
                return true;
            }
            var emails = value.split(",").map(function (x) { return x.trim(); }).filter(function (x) { return x.length > 0; });
            if (emails.length === 0) {
                return true;
            }
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emails.every(function (x) { return emailRegex.test(x); });
        })
            .withMessage("Winning Email Notification must contain valid email addresses separated by commas.")
            .ensure(function (x) { return x.insufficientCreditAlertEmail; })
            .satisfies(function (value) {
            if (!value || value.trim().length === 0) {
                return true;
            }
            var emails = value.split(",").map(function (x) { return x.trim(); }).filter(function (x) { return x.length > 0; });
            if (emails.length === 0) {
                return true;
            }
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emails.every(function (x) { return emailRegex.test(x); });
        })
            .withMessage("Alert Email must contain valid email addresses separated by commas.")
            .on(newItem)
            .rules;
    };
    Brand.prototype.isNewBrand = function () {
        return 'brandId' in this.item && this.item.brandId != 0;
    };
    Brand.prototype.getSteps = function () {
        return [
            {
                title: this.i18N.tr("brand-basic-meta"),
                step: StepEnum.BrandBasicMeta,
                vm: this.brandBasicMeta,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandOverview),
                view: '../../app/admin/brand/steps/brand-basic-meta.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-analytics"),
                step: StepEnum.BrandAnalytics,
                vm: this.brandAnalytics,
                // hide this analytic tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandAnalytics) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-analytics.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-transactions"),
                step: StepEnum.BrandTransactions,
                vm: this.brandTransactions,
                // hide this brand transaction tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandTransactions) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-transactions.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-lotteries"),
                step: StepEnum.BrandLotteries,
                vm: this.brandLotteries,
                // hide this brand lottery list tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandLotteries) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-lotteries.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("lottery-grouping"),
                step: StepEnum.LotteryGrouping,
                vm: this.lotteryGrouping,
                // hide this brand lottery grouping list tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.LotteryGrouping) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/lottery-grouping.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-instant-games"),
                step: StepEnum.BrandInstantGames,
                vm: this.brandInstantGames,
                // hide this brand instant games tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandInstantGames) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-instant-games.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-sweepstakes"),
                step: StepEnum.BrandSweepstakes,
                vm: this.brandSweepstakes,
                // hide this brand instant games tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandSweepstakes) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-sweepstakes.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-bundles"),
                step: StepEnum.BrandBundles,
                vm: this.brandBundles,
                // hide this brand bundles tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandBundles) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-bundles.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("lottery-insurance"),
                step: StepEnum.BrandLotteryInsurance,
                vm: this.lotteryInsurance,
                // hide this brand insurance list depends on lottery list tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandLotteryInsurance) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/lottery-insurance.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("lottery-cost-summary"),
                step: StepEnum.BrandLotteryInsuranceCosts,
                vm: this.lotteryInsurancePrint,
                view: '../../app/admin/brand/steps/lottery-insurance-print.html',
                // hide this brand insurance cost for lottery list tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandLotteryTicketCosts) && this.isNewBrand(),
            },
            {
                loadOnceClicked: true,
                title: this.item.enableAgent ? this.i18N.tr("brand-agents") : this.i18N.tr("brand-players"),
                step: StepEnum.BrandPlayers,
                vm: this.brandPlayers,
                // hide this brand player list tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandPlayers) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-players.html'
            },
            {
                title: this.i18N.tr("brand-settings"),
                step: StepEnum.BrandSettings,
                vm: this.brandSettings,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandSettings),
                view: '../../app/admin/brand/steps/brand-settings.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-render-editor"),
                step: StepEnum.BrandRenderEditor,
                vm: this.brandRenderEditor,
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandSettings) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-render-editor.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("change-log"),
                step: StepEnum.BrandChangeLog,
                vm: this.brandChangeLog,
                // hide this brand change log tab when creating new brand
                show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-changelog.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("billing"),
                step: StepEnum.BrandBilling,
                vm: this.billing,
                // hide this brand billing tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandBilling) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/billing.html'
            },
            {
                loadOnceClicked: true,
                title: this.i18N.tr("brand-permissions"),
                step: StepEnum.BrandNotifications,
                vm: this.brandNotifications,
                // hide this brand permission tab when creating new brand
                show: this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandNotifications) && this.isNewBrand(),
                view: '../../app/admin/brand/steps/brand-notifications.html'
            }
        ];
    };
    Brand.prototype.initializeItemOverrideForUpdate = function (newItem) {
        var euro = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == "eur"; });
        var doesNotHaveEuroCurrency = euro && newItem && newItem.brandCurrencies && !Enumerable.from(newItem.brandCurrencies).any(function (x) { return x.currencyId == euro.currencyId; });
        if (doesNotHaveEuroCurrency)
            this.addEuroCurrency(newItem);
        this.initValidations(newItem);
        this.updatePermissions();
    };
    Brand.prototype.initializeItemOverride = function (newItem) {
        if (newItem && !newItem.createdDate) {
            newItem.createdDate = new Date();
            // this.addEuroCurrency(newItem); - this line is commented causes, adding brand currency double time in db
            this.initValidations(newItem);
        }
        this.updatePermissions();
    };
    Brand.prototype.addEuroCurrency = function (newItem) {
        var euro = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == "eur"; });
        if (euro)
            newItem.brandCurrencies.push({
                currencyId: euro.currencyId
            });
    };
    // Inherited
    Brand.prototype.getItem = function (id) {
        var request = { id: id };
        var promise = this.brandClientService.getBrand(request);
        return promise;
    };
    Brand.prototype.getItemId = function () {
        return this.item.brandId;
    };
    Brand.prototype.getEntityType = function () {
        return EntityTypes.Brand;
    };
    Brand.prototype.saveItem = function (id, changes) {
        var request = { id: id, changes: changes };
        return this.brandClientService.save(request);
    };
    Brand.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageBrand;
    };
    Brand.prototype.initializeItemForCreate = function () {
        return this.defaultBrand;
    };
    Brand.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListBrands;
    };
    Brand.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        Promise.all([
            this.controller.validate({ object: this.item, rules: this.rules }),
        ]).then(function (result) {
            _this.brandNotifications.checkBrandNotificationValues();
            resolve(Enumerable.from(result).all(function (x) { return x.valid; }), _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    Brand.prototype.validateBrandMarginCostFlag = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.brandClientService.validateBrandLotteryMarginCost(this.item.brandId)];
                    case 1:
                        validationData = _a.sent();
                        if (!validationData || !validationData.isValid) {
                            require("./dialogs/brand-lottery-margin-cost-dialog");
                            this.dialogClient.show(DialogServiceConstants.URLs.BrandLotteryMarginCostDialog, validationData, true, true);
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Brand = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Router, TokenClient,
            BindingEngine,
            NotificationClientService,
            EventAggregator,
            BrandClientService,
            BrandBasicMeta,
            BrandAnalytics,
            BrandTransactions,
            BrandLotteries,
            BrandInstantGames,
            BrandSweepstakes,
            BrandBundles,
            LotteryInsurance,
            LotteryInsurancePrint,
            AttachmentClientService,
            BrandPlayers,
            BrandSettings,
            LotteryGrouping,
            BrandChangeLog,
            UserClaimsService,
            ValidationControllerFactory,
            InsuranceDataHandler,
            Billing,
            BrandNotifications,
            BrandRenderEditor,
            I18N,
            DialogClientService])
    ], Brand);
    return Brand;
}(BaseEntity));
export { Brand };
